/* GASSISA
=========================================================================================
* Descripcion: Validacion de permisos exclusiva para formularios portatiles.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de modal portatil independiente
* ---------------------------------------------------------------------------------------
*/

import TextField from "../../ui/TextField";
import { useEffect, useRef, useState } from "react";
import { Button, InputAdornment, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/PersonOutline";
import KeyIcon from "@mui/icons-material/LockOutlined";
import { apiLoginValidator } from "../../../settings/ApiConfig";
import { useSesion } from "../../../context/System/SesionContext";
import { useLayout } from "../../../context/System/LayoutContext";
import SizeSoftXModalPortatil from "../leyout/SizeSoftXModalPortatil.jsx";

export default function FrmLoginValidatePortatil({
  openModal,
  hancleCloseModalValidator,
  tiposUsuario = ["SA", "ADMINISTRADOR"],
  handleComandoEjecucion,
}) {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);
  const usuarioRef = useRef(null);
  const { tokenSeguridad } = useSesion();
  const { handleOpenAlert } = useLayout();

  useEffect(() => {
    if (openModal) setTimeout(() => usuarioRef.current?.focus?.({ preventScroll: true }), 0);
    else {
      setUsuario("");
      setPassword("");
    }
  }, [openModal]);

  const validar = async () => {
    if (!usuario.trim() || !password.trim()) return;
    try {
      const response = await fetch(apiLoginValidator, {
        method: "POST",
        body: JSON.stringify({ sUser: usuario, sPassword: password }),
        headers: { Authorization: `Bearer ${localStorage.getItem("sizesoftx-tenant-access-token") || tokenSeguridad}`, "Content-Type": "application/json", Accept: "application/json" },
      });
      const data = await response.json();
      if (data?.hasError) return handleOpenAlert("Error en credenciales de acceso", "error");
      const tipo = String(data?.result?.TipoUsuario ?? "").trim().toUpperCase();
      if (!tiposUsuario.includes(tipo)) return handleOpenAlert("Usuario sin permisos", "error");
      await handleComandoEjecucion(true, usuario);
      hancleCloseModalValidator();
    } catch (error) {
      handleOpenAlert(`Error al validar credenciales: ${String(error)}`, "error");
    }
  };

  return (
    <SizeSoftXModalPortatil open={openModal} onClose={hancleCloseModalValidator} sx={{ width: "min(92vw, 390px)", p: 2 }}>
      <div className="login-validate-portatil">
        <Typography variant="h6">Validacion de permisos</Typography>
        <TextField inputRef={usuarioRef} label="Usuario" value={usuario} onChange={(event) => setUsuario(event.target.value)} autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start"><PersonIcon /></InputAdornment> }} />
        <TextField label="Contrasena" value={password} onChange={(event) => setPassword(event.target.value)} type="password" autoComplete="off" readOnly={!passwordFocused} onFocus={() => setPasswordFocused(true)} onBlur={() => setPasswordFocused(false)} onKeyDown={(event) => { if (event.key === "Enter") validar(); }} slotProps={{ htmlInput: { enterKeyHint: "enter" } }} InputProps={{ startAdornment: <InputAdornment position="start"><KeyIcon /></InputAdornment> }} />
        <Button variant="contained" onClick={validar}>Entrar</Button>
      </div>
    </SizeSoftXModalPortatil>
  );
}
